export default __webpack_public_path__ + "static/media/offsite.54074722.svg";